import { Component, OnInit } from '@angular/core';
import { AbstractBaseComponent } from '@shared/abstract-base/abstract-base.component';
import { WidenService } from '@services/widen.service';
import { ArticleCollectionContent } from '@marketing/insights/insights.interface';
import { Logger } from '@utils/logger';
import { LinkService } from '@services/link.service';
import { AppStateService } from '@services';

/**
 * Logger
 */
const logger = Logger.getLogger('ArticleCollectionComponent');

/**
 * The Article Collection component
 *
 * Selector: `ft-article-collection`
 *
 * Exported as: `ArticleCollectionComponent`
 */
@Component({
  selector: 'ft-article-collection',
  templateUrl: './article-collection.component.html',
})
export class ArticleCollectionComponent
  extends AbstractBaseComponent
  implements OnInit {
  // Component fields
  content: ArticleCollectionContent;
  translationLabels: any;

  /**
   * Constructor
   */
  constructor(
    private appStateService: AppStateService,
    private widenService: WidenService,
    private ctaLinkService: LinkService
  ) {
    super();
  }

  /**
   * Angular Init Hook
   */
  ngOnInit(): void {
    super.ngOnInit();
    this.content = this.document?.getData<ArticleCollectionContent>();

    // Load translations from resource bundles
    this.translationLabels = this.component?.getModels()[
      'ft.core.insightsLibrary'
    ];

    // Set banner breadcrumbs
    this.setBreadcrumbItems();

    // Format banner image
    if (this.content?.bannerImage) {
      this.content.bannerImage = this.widenService.getWidenAssetUrl(
        this.content.bannerImage.widenDocument
      );
    }

    // Format cards in main body & right rail
    this.formatBlocks(this.content?.content);
    this.formatBlocks(this.content?.rightRail);
  }
  /**
   * Fomrat the card compound for display
   * @param card cardCompound object
   */
  formatBlocks(blocks: any): void {
    for (const block of blocks) {
      // Card compound array
      if (block.cardCompound) {
        for (const card of block.cardCompound) {
          // Format image
          if (card.image) {
            card.image = this.widenService.getWidenAssetUrl(
              card.image.widenAsset
            );
          }
          // Format link
          if (card.link?.linkCollection?.length) {
            card.link = card.link.linkCollection[0];
            card.href = this.ctaLinkService.getCTALink(
              this.page,
              card.link,
              this.appStateService?.getHomePageUrl()
            );
          }
        }
      }
      // End Card formatting
    }
  }
}
